import * as yup from 'yup';

const locationTransactionSchema = yup.object({
  currencyCode: yup.string().required('Currency is required'),
  transactionType: yup.string().required('Account number is required'),
  paymentMethod: yup.string().required('Payment method is required'),
});

const personalInfoSchema = yup.object({
  accountOwnerType: yup.string().required('Account owner type is required'),
  beneficiaryEmail: yup
    .string()
    .required('Beneficiary email is required')
    .email('Enter a valid beneficiary email'),
  streetLine1: yup.string().required('Address line 1 is required'),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  postalCode: yup
    .string()
    .length(6, 'Postal code must be at least 6 characters')
    .matches(/^\d+$/, 'Postal code must contain only numbers')
    .required('Postal code is required'),
  countryCode: yup.string().required('Country is required'),
});

const swiftSchema = yup.object({
  streetLine1: yup.string().required('Street Line 1 is required'),
  streetLine2: yup.string().nullable(),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  postalCode: yup.string().required('Postal code is required'),
  countryCode: yup.string().required('Country code is required'),
  bic: yup.string().required('BIC is required'),
  ibanAccount: yup.string().required('IBAN is required'),
  category: yup.string().required('Category is required'),
});

const ibanSchema = yup.object({
  bankName: yup.string().required('Bank name is required'),
  countryCode: yup
    .string()
    .required('Country code is required')
    .length(2, 'Country code must be exactly 2 characters')
    .matches(/^[A-Z]{2}$/, 'Country code must be uppercase letters'),
  bic: yup.string().required('BIC is required'),
  accountNumber: yup
    .string()
    .matches(/^\d+$/, 'Account number must contain only numbers')
    .required('Account number is required'),
  iban: yup
    .string()
    .required('IBAN is required')
    .matches(
      /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/,
      'Invalid IBAN format. Must start with 2 uppercase letters followed by 2 numbers and up to 30 alphanumeric characters',
    )
    .test(
      'iban-country-match',
      'IBAN country code must match selected country',
      function (value) {
        const countryCode = this.parent.countryCode;
        return !value || !countryCode || value.startsWith(countryCode);
      },
    ),
});

const usdLocalSchema = yup.object({
  bankName: yup.string().required('Bank name is required'),
  accountNumber: yup
    .string()
    .matches(/^\d+$/, 'Account number must contain only numbers')
    .required('Account number is required'),
  routingNumber: yup
    .string()
    .matches(/^\d+$/, 'Routing number must contain only numbers')
    .required('Routing number is required')
    .length(9, 'Routing number must be exactly 9 digits'),
  checkingOrSavings: yup
    .string()
    .oneOf(['checking', 'savings'], "Must be either 'checking' or 'savings'")
    .required('Account Type is required'),
});

const swiftUnknownSchema = yup.object({
  bic: yup.string().required('BIC is required'),
  accountNumber: yup.string().required('Account number is required'),
});

const beneficiarySchemas = [
  locationTransactionSchema,
  personalInfoSchema,
  swiftSchema,
  ibanSchema,
  usdLocalSchema,
  swiftUnknownSchema,
];

export default beneficiarySchemas;
